import { useTranslations } from "use-intl";
import { Divider } from "@mui/material";
import { useWatch } from "react-hook-form";
import dayjs from "dayjs";
import type { TripDetails } from "@/app/lib/types/trip";
import { CollapsibleCard } from "../../CollapsibleCard";
import type { BookingData } from "../../types";
import { DetailsList, DetailsListItem } from "../../DetailsList";
import { RoomList } from "../../RoomList";

type Props = {
  trip: TripDetails;
};

export function TripDetailsCard({ trip }: Props) {
  const t = useTranslations();
  const tripDate = useWatch<BookingData, "tripDate">({ name: "tripDate" });
  const travellers = useWatch<BookingData, "travellers">({
    name: "travellers",
  });

  return (
    <CollapsibleCard title={t("trips.tripDetails.title")} collapsible={false}>
      <DetailsList>
        <DetailsListItem
          title={t("trips.travelStartDate")}
          value={dayjs(tripDate).format("D MMMM, YYYY")}
        />

        <DetailsListItem
          title={t("trips.travelEndDate")}
          value={dayjs(tripDate)
            .add(trip.durationInDays, "day")
            .format("D MMMM, YYYY")}
        />

        <DetailsListItem
          title={t("trips.travelLength")}
          value={t("trips.duration", {
            nights: trip.durationInDays - 1,
            days: trip.durationInDays,
          })}
        />

        <DetailsListItem
          title={t("trips.flightOperator")}
          value={trip.airline}
        />
      </DetailsList>

      <Divider
        sx={{
          borderColor: "var(--color-stroke-neutral-soft)",
          my: "calc(var(--spacing)*3)",
        }}
      />

      <div className="mb-1 text-sm text-text-disabled-primary">
        {t("trips.tripDetails.rooms")}
      </div>
      <RoomList rooms={travellers} />
    </CollapsibleCard>
  );
}
